import { Box, TableRow, Tooltip, Typography } from '@mui/material';
import {
  ActionIconButton,
  DecimalTextField,
  InfoTooltip,
  RowTableCell,
} from '../../../common/components';
import { TABLE_INPUT_CELL_SX, TABLE_INPUT_SX } from '../../../common/styles/tableInputs';
import { RETURN_TEXTS as TEXTS } from '../constants/consumptionReturnTexts';

/** Material con su origen, cantidad y acción de quitar alineada en la última columna. */
const ConsumptionReturnItemRow = ({ row, onQuantity, onRemove, readOnly, receiving }) => (
  <TableRow hover>
    <RowTableCell title={row.article_name} sx={{ textAlign: 'left' }}>
      <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.25 }} noWrap>
        {row.article_name}
      </Typography>
      <Typography variant="caption" component="div" sx={{ color: 'text.secondary' }} noWrap>
        {[row.article_code, row.consumption_number || TEXTS.legacyOrigin, row.unit]
          .filter(Boolean).join(' · ')}
      </Typography>
    </RowTableCell>
    <RowTableCell align="right" sx={{ textAlign: 'right' }}>{row.limit ?? '—'}</RowTableCell>
    <RowTableCell align="right" sx={{ textAlign: 'right', '&&': TABLE_INPUT_CELL_SX }}>
      <DecimalTextField
        size="small"
        decimals={3}
        sx={TABLE_INPUT_SX}
        value={row.quantity}
        disabled={readOnly}
        inputProps={{ style: { textAlign: 'right' }, 'aria-label': TEXTS.quantity }}
        error={row.limit != null && Number(row.quantity) > row.limit}
        onChange={(event) => onQuantity(row.key, event.target.value)}
      />
    </RowTableCell>
    <RowTableCell>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {readOnly && row.cost_pending && (
          <InfoTooltip color="warning" lines={[TEXTS.costPending]} />
        )}
        {!readOnly && !receiving && (
          <Tooltip title={TEXTS.remove}>
            <ActionIconButton
              variant="delete"
              aria-label={TEXTS.remove}
              onClick={() => onRemove(row.key)}
            />
          </Tooltip>
        )}
      </Box>
    </RowTableCell>
  </TableRow>
);

export default ConsumptionReturnItemRow;
